import ServiceResponseCode from '../models/service.response.code'
import APIError from '../models/api/api.error'
import moment from "moment";
import { resolveTheme, resolveThemeLink } from './resolveTheme'
import {
  DEFAULT_LOCALE,
  toDbLocalizacao as mapUiToDbLocalizacao,
  toUiLocale as mapDbToUiLocale,
} from '../models/localizacao'

function readJwtLocalizacao() {
  try {
    const raw = window.localStorage.getItem('user')
    if (!raw || raw === 'undefined')
      return null
    const session = JSON.parse(raw)
    return session?.Usuario?.Usuario?.Localizacao ?? null
  } catch (e) {
    return null
  }
}

export default {
  getTheme() {
    return resolveTheme()
  },
  /** Idiomas.Localizacao / JWT → vue-i18n (pt_br → pt-BR) */
  toUiLocale(localizacaoDb) {
    return mapDbToUiLocale(localizacaoDb)
  },
  /** vue-i18n / app-locale → Idiomas.Localizacao (pt-BR → pt_br) */
  toDbLocalizacao(localeUi) {
    return mapUiToDbLocalizacao(localeUi)
  },
  /** Valor de Idiomas.Localizacao efectivo (JWT se autenticado) */
  currentLocalizacao() {
    const jwtLocalizacao = readJwtLocalizacao()
    if (jwtLocalizacao)
      return jwtLocalizacao
    return this.toDbLocalizacao(localStorage.getItem('app-locale') || DEFAULT_LOCALE)
  },
  getModalidadeFromTheme(theme = null) {
    const resolvedTheme = theme ?? this.getTheme()
    const map = {
      uca: 'EAD',
      esn: 'ESN',
      u4: 'U4',
    }
    return map[resolvedTheme] ?? 'EAD'
  },
  getInstitutionName(theme = null) {
    const resolvedTheme = theme ?? this.getTheme()
    const map = {
      uca: 'Faculdade Católica Paulista',
      esn: 'Escola Superior de Ensino e Negócios',
      u4: 'Unifour University',
    }
    return map[resolvedTheme] ?? map.uca
  },
  getYoutubeVideoId(link) {
    if (!link || typeof link !== 'string') return null

    const watchMatch = link.match(/[?&]v=([\w-]{11})/)
    if (watchMatch) return watchMatch[1]

    const shortMatch = link.match(/youtu\.be\/([\w-]{11})/)
    if (shortMatch) return shortMatch[1]

    const embedMatch = link.match(/\/embed\/([\w-]{11})/)
    if (embedMatch) return embedMatch[1]

    return null
  },
  /**
   * Locale vue-i18n / header HTTP Localizacao.
   * Autenticado: JWT Usuario.Localizacao mapeado; senão app-locale.
   */
  currentLocale() {
    const jwtLocalizacao = readJwtLocalizacao()
    if (jwtLocalizacao)
      return this.toUiLocale(jwtLocalizacao)
    return localStorage.getItem('app-locale') || DEFAULT_LOCALE
  },
  applyLocaleFromJwt(i18nLocaleRef = null) {
    const uiLocale = this.currentLocale()
    if (i18nLocaleRef && typeof i18nLocaleRef === 'object' && 'value' in i18nLocaleRef) {
      i18nLocaleRef.value = uiLocale
    }
    return uiLocale
  },
  getClientUUID() {
    const storageKey = 'uca-lms-client-uuid'
    let clientUUID = localStorage.getItem(storageKey)

    if (!clientUUID) {
      clientUUID = window.crypto?.randomUUID ? window.crypto.randomUUID() : this.generateUUID()
      localStorage.setItem(storageKey, clientUUID)
    }

    return clientUUID
  },
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0
      const v = c == 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  },
  getUCAWhatsappLink() {
    return resolveThemeLink('uca')
  },
  getESNWhatsappLink() {
    return resolveThemeLink('esn')
  },
  getU4WhatsappLink() {
    return resolveThemeLink('u4')
  },
  getWhatsappLink(theme = null) {
    return resolveThemeLink(theme ?? this.getTheme())
  },
  getWhatsappDuvidasLink() {
    return 'https://api.whatsapp.com/send?phone=5514988264000'
  },
  getWhatsappDuvidasNumero() {
    return '(14) 98826-4000'
  },
  getPortalAlunoLink() {
    return 'https://aluno.uca.edu.br'
  },
  getMessageError(result) {
    if (Number(result?.Code) === ServiceResponseCode.TokenAccess || result?.Type === 'auth-redirect') {
      return `${result.Message}|auth-redirect`;
    }

    return `${result.Message}|${result.Type ?? 'error'}`;

  },
  messageExceptionHandler(exception, subErrorMessage = null) {

    if (!exception?.message)
      return

    const message = exception.message.split('|');

    // sessão invalidada: redirect para login já tratado em base.api.service
    if (message[1] === 'auth-redirect' || exception?.isAuthRedirect)
      return

    const localizacao = this.currentLocale()
    let error;
    let warning;
    switch (localizacao) {
      case 'en':
        error = 'Error'
        warning = 'Warning'
        break;
      case 'es':
        error = 'Error'
        warning = 'Advertencia'
        break;
      default:
        error = 'Erro'
        warning = 'Atenção'
    }

    if (message[1])
      switch (message[1]) {
        case 'error':
          swalAlert.fire(error, subErrorMessage ?? message[0], 'error');
          break;
        case 'warning':
          swalAlert.fire(warning, message[0], 'warning');
          break;
      }
    else
      swalAlert.fire('', exception.message, '');

  },
  getServiceResponse(response) {

    if (!response) {
      return {
        Code: ServiceResponseCode.ResponseNotFound,
        Message: 'Not Found',
        Success: false,
        Type: response.Type
      }
    }

    if (response.Success) {
      return {
        Code: response.Code,
        Message: response.Message,
        Success: true,
        Data: response.Data,
        Type: 'success'
      }
    } else {
      return {
        Code: response.Code,
        Message: response.Message,
        Success: false,
        Data: response.Data,
        Type: response.Type,
        HttpCode: response.HttpCode,
      }
    }

  },
  async getHttpErrror(response) {

    if (response.status == 200 || response.status == 201 || response.status == 202 || response.status == 206)
      return null

    if (response.status == 406) {
      return {
        Message: `Não autorizado. Sessão expirada faça o Login novamente`,
        Type: 'error',
        Error: 'Sessão Expirada'
      }
    }

    const url = new URL(response.url);
    const pathOnly = url.pathname.replace('/api/v1/', '');
    const text = await response.text()
    let errorResponse = null

    try {
      errorResponse = text ? JSON.parse(text) : null
    } catch (e) {
      errorResponse = null
    }

    if (errorResponse?.Message) {
      return {
        Code: errorResponse.Code,
        HttpCode: errorResponse.HttpCode ?? response.status,
        Message: errorResponse.Message,
        Success: errorResponse.Success ?? false,
        Data: errorResponse.Data ?? [],
        Type: errorResponse.Type ?? 'error',
        Error: errorResponse.errors ?? errorResponse.Error ?? ''
      }
    }

    return {
      Message: `API Erro: ${response.status}: ${response.statusText}, ${response.type.toUpperCase()}, '${pathOnly}'`,
      Type: 'error',
      Error: errorResponse?.errors ?? ''
    }
  },
  getHttpErrorCode(error) {
    if (!error || !(error instanceof APIError)) {
      return ServiceResponseCode.CatchAPICall
    } else {
      return error?.data?.Code ?? ServiceResponseCode.CatchAPICall
    }
  },
  getURLParams(params = []) {
    if (!params) {
      return ''
    }

    params = params.filter(p => p.Name && p.Value)

    if (params.length == 0) {
      return ''
    }

    let queryString = '?'

    params.forEach(param => {
      queryString += (queryString == '?' ? '' : '&') + param.Name + '=' + encodeURI(param.Value)
    })

    return queryString
  },
  ucWords(s) {
    let str = s.toLowerCase()
    let re = /(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g
    return str.replace(re, s => s.toUpperCase())
  },
  getTokenParam(token, param) {

    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    const data = JSON.parse(jsonPayload)

    return data[param] ?? null

  },
  formatMoney(value) {
    const formCurrency = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      roundingIncrement: 5
    })
    return formCurrency.format(value)
  },
  formatDecimal(value) {
    const formCurrency = new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2
    });
    return formCurrency.format(value)
  },
  formatPercentage(value) {
    return value.toString().replaceAll('.', ',') + '%'
  },
  formatDateTime(dateTime) {
    if (!dateTime) return null
    return moment(dateTime, "YYYY-MM-DDTHH:mm:ss.SSS").format("DD/MM/YYYY HH:mm:ss");
  },
  formatDateHourMin(dateTime) {
    if (!dateTime) return null
    return moment(dateTime, "YYYY-MM-DDTHH:mm:ss.SSS").format("DD/MM/YYYY HH:mm");
  },
  formatDate(dateTime) {
    if (!dateTime) return null
    return moment(dateTime, "YYYY-MM-DDTHH:mm:ss.SSS").format("DD/MM/YYYY");
  },
  formatDateTimeUs(dateTime) {
    if (!dateTime) return null
    return moment(dateTime, "YYYY-MM-DDTHH:mm:ss.SSS").format("YYYY-MM-DD HH:mm:ss");
  },
  formatDatePickerToUs(dateTime) {
    if (!dateTime) return null
    return moment(dateTime, "MM/DD/YYYY").format("YYYY-MM-DD");
  },
  formatDatePicker(dateTime) {
    if (!dateTime) return null
    return moment(dateTime, "YYYY-MM-DDTHH:mm:ss.SSS").format("MM/DD/YYYY");
  },
  extractDateToDateTime(dateTime) {
    if (!dateTime) return null
    return moment(dateTime, "YYYY-MM-DDTHH:mm:ss.SSS").format("YYYY-MM-DD");
  },
  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  },
  mobileOrientation() {

    if (window.orientation === 0 || window.orientation === 180) {
      return 'retrato'
    } else if (window.orientation === 90 || window.orientation === -90) {
      return 'paisagem'
    }

    return 'outro'

  },
  isResponsive() {
    return window.innerWidth <= 992
  },
  scrollToAdjusted(id, offset = 0) {
    const element = document.getElementById(id);
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementPosition - offset,
      behavior: "smooth"
    });
  },
  ukWords(str) {
    let val = ''
    if (str != null) {
      val = str.match(/[a-zA-Z][a-z]+/g)
      val = val.join(' ')
      val = val.toLowerCase().replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function (letter) {
        return letter.toUpperCase();
      });
    }
    return val
  },
  stringToUrl(str) {
    return str.replaceAll(' ', '-').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  },
  getEmbedLinkYoutube(link) {
    const videoId = this.getYoutubeVideoId(link)
    if (!videoId) return null

    // Proxy HTTPS com Referer válido (Evita Erro 152/153 no WebView Capacitor).
    const proxyBase = (process.env.VUE_APP_YOUTUBE_EMBED_URL || '').trim().replace(/\/$/, '')
    if (proxyBase) {
      return `${proxyBase}?v=${encodeURIComponent(videoId)}`
    }

    return `https://www.youtube.com/embed/${videoId}?playsinline=1`
  },
  formatIdDisciplina(id) {
    return ('000000' + id).slice(-6);
  },
  addDaysDate(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  },
  removeDaysDate(date, days) {
    date.setDate(date.getDate() - days);
    return date;
  },
  readFile(file) {

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve({
          url: event.target.result,
          file: file,
        });
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });

  },
  formatMinutes(minutes) {

    if (minutes) {

      const hours = Math.floor(minutes / 60);
      const minutesRemaining = minutes % 60;

      let timeByExtension = '';

      if (hours > 0) {
        timeByExtension += `${hours} hora${hours !== 1 ? 's' : ''}`;
      }

      if (minutesRemaining > 0) {
        if (hours > 0) {
          timeByExtension += ' e ';
        }
        timeByExtension += `${minutesRemaining} minuto${minutesRemaining !== 1 ? 's' : ''}`;
      }

      return timeByExtension;

    }

    return 'Tempo livre'
  },
  validarHorario(horario) {
    // Verifica se o formato do horário é válido
    if (/^([01]\d|2[0-3]):([0-5]\d)$/.test(horario)) {
      // Divide as partes do horário
      var partes = horario.split(":");
      var horas = parseInt(partes[0]);
      var minutos = parseInt(partes[1]);

      // Verifica se as horas e os minutos estão dentro dos limites
      if (horas >= 0 && horas <= 23 && minutos >= 0 && minutos <= 59) {
        return true; // Horário válido
      }
    }

    return false; // Horário inválido
  },
  getGuid() {
    return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16).toUpperCase();
    })
  },
}
